import { render, staticRenderFns } from "./NewReadiness.vue?vue&type=template&id=6c504540&scoped=true"
import script from "./NewReadiness.vue?vue&type=script&lang=js"
export * from "./NewReadiness.vue?vue&type=script&lang=js"
import style0 from "./NewReadiness.vue?vue&type=style&index=0&id=6c504540&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c504540",
  null
  
)

export default component.exports